module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';

	fox.registerWidget('User_PasswordRecovery_Email', {

		configure: function(options) {

			this.registerOptions('', {
				errorContainer: '#recovery-message',
				template: 'user_passwordrecovery_email',
				successfulAction: false,
				widgets: {
					recoveryApi: {
						widget: 'Api',
						method: 'passwordRecovery.sendRecoveryMail'
					},
					form: {
						widget: 'DomForm',
						formSelector: '#email-form',
						elements: {
							email: {
								validators: [
									{ validator: 'regexp', options: { type: 'email' }, message: 'Email address is invalid' }
								]
							}
						},
						'handleDom.submit': {
							event: 'submit',
							target: '#email-form'
						},
						'handleWom.formValid': {
							widget: '@this',
							event: ['form_valid', 'form_not_valid'],
							callback: '@parent:formInvalidate'
						}
					},
					successPopup: {
						widget: 'Popup_Common',
						'widgets.content.template': 'popup_user_passwordRecoverySuccess'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		submit: function(data) {

			if (!this.callParent('submit', arguments)) {
				return false;
			}

			this._inProgress = true;
			
			this.toggleLoader(true);
			this.recover(data);
		},

		handleResponse: function(resp) {
			this.callParent('handleResponse', arguments);

			if (!this.getOption('successfulAction')){
				this.rwom1('#successPopup').show();
			} else {
				var successPage = this.getOption('successfulAction');
				successPage(this);
			}
			
		},

		recover: function(data) {
			this.wom1('#recoveryApi')
				.psend(data)
				.then(this.handleResponse.bind(this))
				.catch(this.handleError.bind(this));
		}

	}, 'User_PasswordRecovery_Base');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/main/widget/user/passwordRecovery/email.js
// module id = 143
// module chunks = 4